import store from '@/store';
import AuthService from '@/common/services/auth.service';
import { SET_USER_ROLE } from '@/store/mutations/auth.mutations';

export const IsStudentGuard = (to, from, next) => {
  const role = AuthService.role();
  if (role === AuthService.ROLES.STUDENT || role === AuthService.ROLES.STUDENT_ONLY) {
    store.commit(SET_USER_ROLE, role);
    return next();
  }

  return next('404');
};